<template lang="pug">
  .rule__container
    .rule__control-group.rule__control-group--select
      label(
        class="label__rule"
      ) Type

      select(
        class="form__select"
        @change="setActiveType"
        v-model="activeType"
      )
        option(
          :key="`${type.label}-${index}`"
          v-for="(type, index) in getInteractionTypes()"
          :value="type"
        ) {{type.label}}
    .rule__control-group.rule__control-group--select(
      v-if="activeType.props && activeType.props.length"
    )
      label(
        class="label__rule"
      ) Property
      select(
        class="form__select"
        @change="setActiveProperty"
        v-model="activeProperty"
      )
        option(
          :key="`${prop.key}-${index}`"
          v-for="(prop, index) in activeType.props"
          :value="prop"
        ) {{prop.key}}
    .rule__control-group.rule__control-group--select(
      v-if="activeProperty && activeProperty.operators && activeProperty.operators.length"
    )
      label(
        class="label__rule"
      ) Operator
      select(
        class="form__select"
        @change="setActiveOperator"
        v-model="activeOperator"
      )
        option(
          :key="`${operator}-${index}`"
          v-for="(operator, index) in activeProperty.operators"
          :value="operator"
        ) {{operator}}
    .rule__control-group.rule__control-group--select(
      v-if="activeProperty && activeProperty.comparands && activeProperty.comparands.length"
    )
      label(
        class="label__rule"
      ) Comparand
      select(
        class="form__select"
        @change="setActiveComparand"
        v-model="activeComparand"
      )
        option(
          :key="`${comparand}-${index}`"
          v-for="(comparand, index) in activeProperty.comparands"
          :value="comparand"
        ) {{comparand}}
    .rule__control-group(
      v-if="activeProperty && !activeProperty.comparands.length"
    )
      label(
        class="label__rule"
      ) Comparand
      input#comparandInput(
        @change="setActiveComparand"
        class="input__text"
        type="text"
        v-model="activeComparand"
      )
    span(
      @click="removeRule"
    )
      CloseIcon(
        class="remove__icon"
      )
</template>
<script>
import store from '../../store';
import vSelect from 'vue-select';
import CloseIcon from 'vue-material-design-icons/Close';
export default {
  components: {
    CloseIcon,
    vSelect
  },
  props: {
    groupIndex: Number,
    ruleIndex: [Number, String]
  },
  data() {
    return {
      activeType: {
        name: null,
        props: null
      },
      ruleType: null,
      activeProperty: null,
      activeOperator: null,
      activeComparand: null
    };
  },
  methods: {
    setActiveType(value) {
      this.activeProperty = null;
      if (!value) {
        this.activeType = {
          name: null,
          props: [null]
        };
      }
      this.updateRule('1');
    },
    setActiveProperty(value) {
      this.activeOperator = null;
      if (!value) {
        this.activeProperty = null;
      }
      this.updateRule('2');
    },
    setActiveOperator(value) {
      this.activeComparand = null;

      if (!value) {
        this.activeOperator = null;
      }
      this.updateRule('3');
    },
    setActiveComparand(value) {
      if (!value) {
        this.activeComparand = null;
      }
      this.updateRule('4');
    },
    updateRule(num) {
      let wholePolicy = store.getters.getActivePolicy;
      let ruleToUpdate =
        wholePolicy.rules[this.groupIndex].groupRules[this.ruleIndex];
      ruleToUpdate.interactionType = this.activeType;
      ruleToUpdate.property = this.activeProperty;
      ruleToUpdate.operator = this.activeOperator;
      ruleToUpdate.comparand = this.activeComparand;

      wholePolicy.rules[this.groupIndex].groupRules[
        this.ruleIndex
      ] = ruleToUpdate;

      store.commit('setActivePolicy', wholePolicy);
    },
    removeRule() {
      let activePolicy = store.getters.getActivePolicy;
      activePolicy.rules[this.groupIndex].groupRules.splice(this.ruleIndex, 1);
      if (activePolicy.rules[this.groupIndex].groupRules.length == 0) {
        activePolicy.rules.splice(this.groupIndex, 1);
      }
      store.commit('setActivePolicy', activePolicy);
    },
    getCurrentRule() {
      if (store.getters.getActivePolicy.rules) {
        return store.getters.getActivePolicy.rules[this.groupIndex].groupRules[
          this.ruleIndex
        ];
      } else {
        return {};
      }
    },
    getInteractionTypes() {
      return store.getters.getInteractionTypes;
    }
  },
  created() {
    if (this.getCurrentRule().interactionType) {
      this.activeType = this.getCurrentRule().interactionType;
    }
    if (this.getCurrentRule().property) {
      this.property = this.getCurrentRule.property;
      this.activeProperty = this.getCurrentRule().property;
    }
    if (this.getCurrentRule().comparand) {
      this.activeComparand = this.getCurrentRule().comparand;
    }
    if (this.getCurrentRule().operator) {
      this.activeOperator = this.getCurrentRule().operator;
    }
  }
};
</script>
<style lang="scss">
.rule__control-group.rule__control-group--select:after {
  top: 21px;
}
.remove__icon {
  cursor: pointer;
  color: #777;
  font-size: 1.1rem;
  position: absolute;
  top: 1.85rem;
  right: -0.1rem;

  @media all and (max-width: 1290px) {
    top: 0;
  }

  &:hover {
    color: darken(#777, 10%);
  }
}
.v-select .dropdown-toggle {
  background: #fff;
  min-width: 240px;
  width: 95%;
}

.rule__container {
  display: flex;
  // justify-content: space-between;
  flex-flow: row wrap;
  position: relative;
  width: 100%;

  @media all and (max-width: 768px) {
    display: block;
  }
}

.rule__control-group {
  padding: 0.5rem;
  width: 24.5%;

  @media all and (max-width: 1290px) {
    width: 50%;
  }

  @media all and (max-width: 768px) {
    width: 100%;
  }
}

.v-select {
  transition: all 0.4s;
}

.v-select.open .dropdown-toggle {
  box-shadow: 0 2px 5px 5px lighten(#09a3ed, 40%);
}

.v-select.open .open-indicator::before {
  transform: rotate(133deg) !important;
}

.label__rule {
  margin-bottom: 3px;
  display: block;
}

.v-select .open-indicator::before {
  margin-top: -5px;
  // margin-right: 5px;
}

.input__text {
  width: 100%;
}

#comparandInput {
  border: 1px solid rgba(60, 60, 60, 0.26);
  height: 47px;
}
</style>




// WEBPACK FOOTER //
// src/components/general/Rule.vue